import React from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {useTranslation} from "@pg-mono/i18n";

import {useAnimatedHomepageHeader} from "../hooks/use_animated_homepage_header";

export const HomepageHeaderContent = () => {
    const copy = [
        "85 000 nowych mieszkań. Jedno dla Ciebie",
        "Największy wybór od deweloperów",
        "Sprawdzone inwestycje. Zero prowizji",
        "Bez agenta, bez prowizji",
        "Wybieraj spośród najlepszych ofert"
    ];
    const translatedCopy = useTranslation(copy);
    const [headline, ...subHeadlines] = translatedCopy ? translatedCopy : copy;
    const subHeadline = useAnimatedHomepageHeader(subHeadlines, subHeadlineStyle);

    return (
        <div className={homepageHeaderContent}>
            <Text as="h1" align="center" fontFamily="secondary" className={headlineStyle}>
                {headline}
                {subHeadline}
            </Text>
        </div>
    );
};

const homepageHeaderContent = css({
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    position: "relative"
});

const headlineStyle = css({
    color: "#fff",
    fontSize: "3.2rem",
    fontWeight: 700,
    lineHeight: "3.84rem",
    maxWidth: "74rem",
    mb: 0,
    textShadow: "0 2px 18px rgba(0, 0, 0, 0.35)",
    zIndex: 1,

    md: {
        fontSize: "5.2rem",
        lineHeight: "6.24rem",
        mb: 0
    },

    lg: {
        fontSize: "5.6rem",
        lineHeight: "6.72rem",
        maxWidth: "114rem"
    }
});

const subHeadlineStyle = css({
    display: "block",
    mt: 0.5,
    fontSize: "2rem",
    fontWeight: 400,
    lineHeight: "2.8rem",

    md: {
        mt: 1,
        fontSize: "3rem",
        lineHeight: "3.8rem"
    },

    lg: {
        fontSize: "4.4rem",
        lineHeight: "5.2rem"
    }
});
import React from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {useTranslation} from "@pg-mono/i18n";

import {useAnimatedHomepageHeader} from "../hooks/use_animated_homepage_header";

export const HomepageHeaderContent = () => {
    const copy = [
        "85 000 nowych mieszkań. Jedno dla Ciebie",
        "Największy wybór od deweloperów",
        "Sprawdzone inwestycje. Zero prowizji",
        "Bez agenta, bez prowizji",
        "Wybieraj spośród najlepszych ofert"
    ];
    const translatedCopy = useTranslation(copy);
    const [headline, ...subHeadlines] = translatedCopy ? translatedCopy : copy;
    const subHeadline = useAnimatedHomepageHeader(subHeadlines, subHeadlineStyle);

    return (
        <div className={homepageHeaderContent}>
            <Text as="h1" align="center" fontFamily="secondary" className={headlineStyle}>
                {headline}
                {subHeadline}
            </Text>
        </div>
    );
};

const homepageHeaderContent = css({
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    position: "relative"
});

const headlineStyle = css({
    color: "#fff",
    fontSize: "3.2rem",
    fontWeight: 700,
    lineHeight: "3.84rem",
    maxWidth: "74rem",
    mb: 0,
    textShadow: "0 2px 18px rgba(0, 0, 0, 0.35)",
    zIndex: 1,

    md: {
        fontSize: "5.2rem",
        lineHeight: "6.24rem",
        mb: 0
    },

    lg: {
        fontSize: "5.6rem",
        lineHeight: "6.72rem",
        maxWidth: "114rem"
    }
});

const subHeadlineStyle = css({
    display: "block",
    mt: 0.5,
    fontSize: "2rem",
    fontWeight: 400,
    lineHeight: "2.8rem",

    md: {
        mt: 1,
        fontSize: "3rem",
        lineHeight: "3.8rem"
    },

    lg: {
        fontSize: "4.4rem",
        lineHeight: "5.2rem"
    }
});
